import { Paper, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { useSelector } from "react-redux";
import { CustomItemTooltip } from "../../../ResuableChartTooltip/CustomItemTooltip";

//const costData = [1, 2, 1, 3, 3, 2, 2, 2, 1, 3, 1, 2, 2, 3, 3];
// const month = [
//   "01/07/25",
//   "02/07/25",
//   "03/07/25",
//   "04/07/25",
//   "05/07/25",
//   "06/07/25",
//   "07/07/25",
//   "08/07/25",
//   "09/07/25",
//   "10/07/25",
//   "11/07/25",
//   "12/07/25",
//   "13/07/25",
//   "14/07/25",
//   "15/07/25",
// ];

const WeightedByCost = () => {
  const { costWeightChartData } = useSelector(
    (state: any) => state.landingPageExperience
  );
  const sortedData =
    costWeightChartData?.length > 0
      ? [...costWeightChartData].sort(
          (a: any, b: any) =>
            new Date(a.date).getTime() - new Date(b.date).getTime() // ASC
        )
      : [];

  const month = sortedData.map((item: any) => item.date);
  const costData =
    costWeightChartData?.length > 0 &&
    costWeightChartData?.map((date: any) => date.lp_exp_score_weight);
  return (
    <>
      <Paper sx={{ padding: "20px 16px", mb: 2 }}>
        <Typography fontSize={24}>
          Average LP Experience per day, weighted by cost
        </Typography>
        {costWeightChartData?.length > 0 ? (
          <BarChart
            height={300}
            margin={{ left: 32, right: 32 }}
            series={[
              {
                data: costData,
                yAxisId: "rightAxis",
                color: "#8133F1",
              },
            ]}
            leftAxis={null}
            rightAxis={{}}
            xAxis={[
              {
                data: month,
                scaleType: "band",
                disableLine: false,
                disableTicks: true,
              },
            ]}
            grid={{ horizontal: true }}
            yAxis={[
              {
                id: "rightAxis",
                //   position: "right",
                disableTicks: true,
                disableLine: true,
              },
            ]}
          >
            <CustomItemTooltip />
          </BarChart>
        ) : (
          <Typography fontSize={20} sx={{ textAlign: "center", mt: "20px" }}>
            No data to display
          </Typography>
        )}
      </Paper>
    </>
  );
};

export default WeightedByCost;
